import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';


export const postService = {
    create,
    update,
    getAll,
    getByType,
    getById,
    getBySlug,
    remove,
    searchPost,
    getSlides,
    getCards,
    getImageUrl,
    fetchCategoryDetails,
    getProducts,
    getNews,
    getBranches,
    getSettingsWoo,
    getByTypeNews,
    getParentId,
    getChild,
    getBranchesFooter
};

function create(body){

    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(body)
    };
    
    return fetch(Config.api.basepath+`/post`, requestOptions).then(handleResponse)
}

function update(body) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };

    return fetch(Config.api.basepath+`/post/`+body._id, requestOptions).then(handleResponse);
}

function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/post?`;

    url = options.page ? url + `page=` + options.page : url
    url = options.items ? url + `&per-page=` + options.items : url
    url = options.limit ? url + `&limit=` + options.limit : url;

    let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
        return r.concat(k + ':' + options.filter[k]);
    }, []);

    url = options.filter ? url + `&filter=` + filter : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            posts => {
                let pages = parseInt(posts.total / posts['per-page']);
                pages = posts.total > ( pages * posts['per-page'] ) ? pages + 1 : pages;
                posts.pages = pages;

                return posts;
            },
            error => {
                return {error: 'Fetch Post Error. Service Unavailable.'};
            }
        );
}


function getByTypeNews(type, page = 1, perPage = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    const _perPage = perPage || Config.pagination.limit;

    return fetch(Config.api.basepath+`/wp-json/wp/v2/news?page=${page}&per-page=${_perPage}&filter=type:${type}&sort=order:ASC&acf_format=standard`, requestOptions)
        .then(handleResponse)
        .then(
            posts => {
                let pages = parseInt(posts.total / posts['per-page']);
                pages = posts.total > ( pages * posts['per-page'] ) ? pages + 1 : pages;
                posts.pages = pages;

                return posts;
            },
            error => {
                return {error: 'Fetch Post Error. Service Unavailable.'};
            }
        );
}

function getByType(type, page = 1, perPage = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    const _perPage = perPage || Config.pagination.limit;

    return fetch(Config.api.basepath+`/wp/v2/${type}?page=${page}&per-page=${_perPage}&filter=type:${type}&sort=order:ASC&acf_format=standard`, requestOptions)
        .then(handleResponse)
        .then(
            posts => {
                let pages = parseInt(posts.total / posts['per-page']);
                pages = posts.total > ( pages * posts['per-page'] ) ? pages + 1 : pages;
                posts.pages = pages;

                return posts;
            },
            error => {
                return {error: 'Fetch Post Error. Service Unavailable.'};
            }
        );
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(Config.api.basepath+`/post/${id}`, requestOptions).then(handleResponse);
}

function getBySlug(slug) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(Config.api.basepath+`/wp/v2/pages?slug=${slug}&acf_format=standard`, requestOptions).then(handleResponse);
    // return fetch(Config.api.basepath+`/wp-json/post/slug/${slug}`, requestOptions).then(handleResponse);
}

function getParentId(slug){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(Config.api.basepath+`/wp/v2/pages?slug=${slug}&acf_format=standard`, requestOptions)
    .then(handleResponse)
    .then(res => {
        return res[0].id
    })
}

function getBranchesFooter(type) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(Config.api.basepath + `/wp/v2/${type}`, requestOptions)
        .then(branchesResponse => {
            if (!branchesResponse.ok) {
                throw new Error('Failed to fetch Post Type');
            }
            return branchesResponse.json();
        })
        .then(res => { return res })
}

function getChild(id){
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(Config.api.basepath+`/wp/v2/pages?parent=${id}&acf_format=standard`, requestOptions)
    .then(handleResponse)
    .then(res => {
        return res
    })

}

function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/post/`+id, requestOptions).then(handleResponse);
}

function searchPost(post, page, perPage) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    // const post = post ? post.replace(' ', '%20') : '';

    const _pageNum = page || 1;
    const _perPage = perPage || Config.pagination.limit;
    
    return fetch(Config.api.basepath+`/post?page=${_pageNum}&per-page=${_perPage}&search=title:${post}`, requestOptions).then(handleResponse)  
}

function getSlides () {
    return fetch('/wp-json/wp/v2/ml-slide?per_page=15')
    .then(response => response.json())
    .then(data => {
        //console.log(data.sort((a, b) => a.featured_media - b.featured_media))
        data.sort((a, b) => a.id - b.id);
        const slidePromises = data.map(slide => {
            //console.log(slide)
            const mediaLink = slide["_links"]["wp:featuredmedia"][0]["href"];
            const getProductUrl = slide.excerpt.rendered ? slide.excerpt.rendered.replace(/<[^>]+>|\n/g, '') : "#"

            return fetch(mediaLink)
                .then(response => response.json())
                .then(mediaData => ({
                    id: slide.id,
                    title: slide.title.rendered,
                    imageUrl: mediaData.source_url,
                    productUrl: getProductUrl
                }))
                .catch(error => console.error("Error fetching media data:", error));
        });

        return Promise.all(slidePromises); // Return the Promise chain
    })
    .catch(error => {
        console.error("Error fetching slides:", error);
        throw error; // Rethrow the error to handle it where the function is called
    });
  };


  function getCards() {
    return fetch('/wp-json/wp/v2/card')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            
            const imageIds = data.map(item => item.acf['background-img']);
            const cardIds = data.map(item => item.acf['card']);
            const categoryIds = data.map(item => item.acf['categories']);

            const imagePromises = imageIds.map(imageId => getImageUrl(imageId));
            const imageCardPromises = cardIds.map(cardId => getImageUrl(cardId));

            const categoryPromises = data.map(item => {
                const categoryLinks = item._links['acf:term'].map(link => link.href);
                const categoryDetailPromises = categoryLinks.map(link => fetchCategoryDetails(link));
                return Promise.all(categoryDetailPromises);
            });

            return Promise.all([...imagePromises, ...categoryPromises, ...imageCardPromises])
                .then(results => {
                    const imageUrls = results.slice(0, imageIds.length);
                    const categoryDetails = results.slice(imageIds.length, imageIds.length + categoryPromises.length);
                    const imageCardUrls = results.slice(imageIds.length + categoryIds.length);

                    return data.map((item, index) => ({
                        ...item,
                        imageUrl: imageUrls[index],
                        categoryDetails: categoryDetails[index],
                        imageCardUrl: imageCardUrls[index]
                    }));
                });
        })
        .catch(error => {
            console.error('Error fetching data:', error);
            throw error;
        });
}


function getImageUrl(imageId) {
    return fetch(`/wp-json/wp/v2/media/${imageId}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch image URL');
            }
            return response.json();
        })
        .then(data => data.source_url)
        .catch(error => {
            console.error('Error fetching image URL:', error);
            return null;
        });
}

function fetchCategoryDetails(categoryUrl) {
    return fetch(categoryUrl)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch category');
            }
            return response.json();
        })
        .catch(error => {
            console.error('Error fetching category:', error);
            return null;
        });
}


function getProducts(slugName) {
    const baseUrl = window.location.origin;

    // Function to fetch tag by slug
    const fetchTagId = () => {
        const tagRequestData = {
            url: `${baseUrl}/wp-json/wc/v3/products/tags?slug=${slugName}`,
            method: 'GET'
        };
        const tagHeaders = oauthFunction().toHeader(oauthFunction().authorize(tagRequestData));

        return fetch(tagRequestData.url, {
            method: tagRequestData.method,
            headers: tagHeaders
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch tag');
            }
            return response.json();
        })
        .then(tagData => {
            return tagData.length > 0 ? tagData[0].id : null;
        });
    };

    // Function to fetch category by slug
    const fetchCategoryId = () => {
        const categoryRequestData = {
            url: `${baseUrl}/wp-json/wc/v3/products/categories?slug=${slugName}`,
            method: 'GET'
        };
        const categoryHeaders = oauthFunction().toHeader(oauthFunction().authorize(categoryRequestData));

        return fetch(categoryRequestData.url, {
            method: categoryRequestData.method,
            headers: categoryHeaders
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch category');
            }
            return response.json();
        })
        .then(categoryData => {
            return categoryData.length > 0 ? categoryData[0].id : null;
        });
    };

    // Function to fetch products by tag and category IDs
    const fetchProductsByIds = (tagId, categoryId) => {
        let url = `${baseUrl}/wp-json/wc/v3/products?per_page=6`;
        if (tagId) url += `&tag=${tagId}`;
        if (categoryId) url += `&category=${categoryId}`;

        const productsRequestData = {
            url: url,
            method: 'GET'
        };
        const productsHeaders = oauthFunction().toHeader(oauthFunction().authorize(productsRequestData));

        return fetch(productsRequestData.url, {
            method: productsRequestData.method,
            headers: productsHeaders
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch products');
            }
            return response.json();
        });
    };

    // Fetch tag ID and category ID, then fetch products
    return Promise.all([fetchTagId(), fetchCategoryId()])
        .then(([tagId, categoryId]) => {
            if (tagId || categoryId) {
                return fetchProductsByIds(tagId, categoryId);
            } else {
                throw new Error('Tag or category not found');
            }
        });
}



function oauthFunction() {
    
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });


    return oauth
}


function getNews(type, tagSlug = null) {
    const fetchNews = (url) => {
        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch post types');
                }
                return response.json();
            })
            .then(data => {
                // Helper function to fetch image URL by ID
                const getImageUrl = (id) => {
                    return fetch(`/wp-json/wp/v2/media/${id}`)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Failed to fetch image');
                            }
                            return response.json();
                        })
                        .then(imageData => imageData.source_url)
                        .catch(() => null); // Handle failure by returning null
                };

                // Extract image IDs from both acf and wp:featuredmedia
                const imagePromises = data.map(item => {
                    const acfImageId = item.acf ? item.acf['image'] : null;
                    const mediaLink = item._links && item._links['wp:featuredmedia'] && item._links['wp:featuredmedia'][0] && item._links['wp:featuredmedia'][0].href;

                    if (acfImageId) {
                        return getImageUrl(acfImageId).then(acfImageUrl => ({ ...item, acfImageUrl }));
                    }

                    if (mediaLink) {
                        return fetch(mediaLink)
                            .then(imageResponse => {
                                if (!imageResponse.ok) {
                                    throw new Error('Failed to fetch image for item');
                                }
                                return imageResponse.json();
                            })
                            .then(imageData => ({ ...item, imageSrc: imageData.source_url }))
                            .catch(() => ({ ...item, imageSrc: null })); // Handle image fetch failure gracefully
                    }

                    return Promise.resolve({ ...item, imageSrc: null }); // If no featured media link, return item with null imageSrc
                });

                return Promise.all(imagePromises)
                    .then(itemsWithImages => {
                        return {
                            items: itemsWithImages.map(item => ({
                                ...item,
                                imageUrl: item.acfImageUrl || item.imageSrc || null
                            })),
                            loading: false,
                            error: ''
                        };
                    });
            })
            .catch(error => {
                return {
                    error: error.message,
                    loading: false
                };
            });
    };

    // If a tag slug is provided, first fetch the tag ID and then fetch the news
    if (tagSlug) {
        return getTagIdBySlug(tagSlug)
            .then(tagId => {
                const url = `/wp-json/wp/v2/${type}?tags=${tagId}`;
                return fetchNews(url);
            })
            .catch(error => {
                return {
                    error: error.message,
                    loading: false
                };
            });
    } else {
        const url = `/wp-json/wp/v2/${type}`;
        return fetchNews(url);
    }
}

function getTagIdBySlug(slug) {
    return fetch(`/wp-json/wp/v2/tags?slug=${slug}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch tag ID');
            }
            return response.json();
        })
        .then(tags => {
            if (tags.length === 0) {
                throw new Error('Tag not found');
            }
            return tags[0].id;
        });
}


function getBranches(type,tag) {
    return fetch(`/wp-json/wp/v2/${type}`)
        .then(branchesResponse => {
            if (!branchesResponse.ok) {
                throw new Error('Failed to fetch Post Type');
            }
            return branchesResponse.json();
        })
        .then(branchesData => {
            return fetch(`/wp-json/wp/v2/tags?slug=${tag}`)
                .then(tagResponse => {
                    if (!tagResponse.ok) {
                        throw new Error('Failed to fetch tag data');
                    }
                    return tagResponse.json();
                })
                .then(tagData => {
                    const tagID = tagData.length > 0 ? tagData[0].id : null;
                    return fetch(`/wp-json/wp/v2/posts?tags=${tagID}`)
                        .then(postsResponse => {
                            if (!postsResponse.ok) {
                                throw new Error('Failed to fetch posts');
                            }
                            return postsResponse.json();
                        })
                        .then(postsData => {
                            // Fetch image URL for each news item
                            const newsWithImages = branchesData.map(async (item) => {
                                const imageResponse = await fetch(item._links['wp:featuredmedia'][0].href);
                                if (!imageResponse.ok) {
                                    throw new Error('Failed to fetch image for item');
                                }
                                const imageData = await imageResponse.json();
                                const imageSrc = imageData.source_url;
                                return { ...item, imageSrc }; // Include imageSrc in the news item
                            });

                            // Handle the fetched data as needed
                            return Promise.all(newsWithImages)
                                .then(itemsWithImages => {
                                    return {
                                        items: itemsWithImages,
                                        viewProducts: postsData,
                                        loading: false,
                                        error: ''
                                    };
                                });
                        });
                });
        })
        .catch(error => {
            console.error('Fetch error:', error);
            return {
                error: error.message,
                loading: false
            };
        });
}


function getSettingsWoo() {
    const baseUrl = window.location.origin;
    // Fetch "settings"
    const settingsData = {
        url: `${baseUrl}/wp-json/wc/v3/settings/general`,
        method: 'GET'
    };
    const settingHeader = oauthFunction().toHeader(oauthFunction().authorize(settingsData));

    return fetch(settingsData.url, {
        method: settingsData.method,
        headers: settingHeader
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to fetch general settings');
        }
        return response.json();
    })
    .then(settingData => {
        const addressFields = {
            woocommerce_store_address: '',
            woocommerce_store_address_2: '',
            woocommerce_store_city: '',
            woocommerce_store_state: '',
            woocommerce_store_postcode: '',
            woocommerce_default_country: ''
        };

        let countryOptions = {};

        settingData.forEach(setting => {
            if (setting.id === 'woocommerce_default_country' && setting.options) {
                countryOptions = setting.options;
            }
            if (Object.keys(addressFields).includes(setting.id)) {
                addressFields[setting.id] = setting.value;
            }
        });

        const formattedAddressParts = [
            addressFields.woocommerce_store_address,
            addressFields.woocommerce_store_address_2,
            addressFields.woocommerce_store_city,
            addressFields.woocommerce_store_state,
            addressFields.woocommerce_store_postcode
        ].filter(part => part && part.trim() !== '');

        let countryName = '';
        const defaultCountry = addressFields.woocommerce_default_country;
        if (defaultCountry.includes(':')) {
            const [countryCode, stateCode] = defaultCountry.split(':');
            const stateName = countryOptions[`${countryCode}:${stateCode}`] || stateCode; // Use options or fallback to state code
            countryName = `${stateName}`;
        } else {
            countryName = countryOptions[defaultCountry];
        }

        formattedAddressParts.push(countryName);

        const formattedAddress = formattedAddressParts.join(', ');
        return formattedAddress;
    })
    .catch(error => {
        return Promise.reject(error.message);
    });
}



function handleResponse(response) {
    return response.text().then(text => {
        if(text.charAt(0)==='<'){
            return Promise.reject({error: 'Unexpected return. not JSON format.'});
        }
        
        const data = text && JSON.parse(text);
        
        if (!response.ok) {
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}